import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import clsx from 'clsx';
function _CloseMiniLine(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return _jsx("span", { className: classes, ref: ref, ...rest, children: _jsx("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", children: _jsx("path", { fill: "currentColor", fillRule: "evenodd", d: "M15.646 7.646a.5.5 0 0 1 .708.708L12.707 12l3.647 3.646a.5.5 0 0 1-.708.708L12 12.707l-3.646 3.647a.5.5 0 0 1-.708-.708L11.293 12 7.646 8.354a.5.5 0 1 1 .708-.708L12 11.293z", clipRule: "evenodd" }) }) });
}
const CloseMiniLine = forwardRef(_CloseMiniLine);
export { CloseMiniLine };
